import { extend } from 'sk-ui/lib/utils/util.js'

import featureValueForm from './metaData/featureValueForm'

export default {
  FeatureValueCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: featureValueForm,
      props
    })
  },
  FeatureValueEdit({ commit }, params) {
    const props = {
      title: '编辑功能价值',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, featureValueForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
